import registrationInstance from '../../instance'

const getAuthentication = () => {
  return registrationInstance.get('/auth/authenticated')
}

export default getAuthentication
